<div id="admissions-registration" class="inner-page">
  <div class="container-fluid px-lg-5">
    <h2 class="title">Registration for Admissions</h2>
    <p class="inner-lead mt-3">
      Interested candidates can register online for admission to Shah Satnam Ji Girls' College, Sirsa for the academic session 2025–26. Please fill in the registration form with accurate details and submit the required documents as per the guidelines.
    </p>
    <hr class="divider">
    <h4 class="section-subtitle">How to Apply</h4>
    <ul class="inner-lead">
      <li>Click the Registration button below to open the online form</li>
      <li>Fill in all personal and academic details accurately</li>
      <li>Upload required documents (marksheets, certificates, photo)</li>
      <li>Submit the form and note your registration number</li>
      <li>Visit the college for document verification on the assigned date</li>
    </ul>
    <hr class="divider">
    <div class="text-center mt-section">
      <a href="https://docs.google.com/forms/d/e/1FAIpQLScZ3eOmPZ9h4PEXTBWP9cj_t3oxyVXorWj59UC8TX48k2XJHA/viewform"
         target="_blank"
         class="pdf-download-btn"
         style="font-size:16px; padding: 12px 28px;">
        <i class="fa fa-edit"></i> Register Online for Admissions
      </a>
    </div>
  </div>
</div>
